import React from 'react';

import { useTranslator } from 'tradera-lang';
import HeartIcon from '@tradera/blueprint/theme/icons2/heart.svg?jsx';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';

const WishListInfoCard = ({ onClose }) => {
    const { t } = useTranslator();
    return (
        <div
            className="flex-shrink-0 px-3 pb-2"
            style={{ width: 150, marginBottom: '2rem' }}>
            <div className="bg-secondary h-100 p-4 d-flex flex-column align-items-center position-relative">
                <CloseIcon
                    className="icon icon-sm position-absolute cursor-pointer"
                    onClick={onClose}
                    style={{
                        padding: 10,
                        boxSizing: 'content-box',
                        top: 0,
                        right: 0
                    }}
                    role="button"
                    aria-label="Hide info card"
                />
                <HeartIcon className="icon icon-xl flex-grow-1" />
                <span>{t('wishList_infoCardText')}</span>
            </div>
        </div>
    );
};

export default WishListInfoCard;
